import { PurchaseDialog } from "@features/dashboard/components/PurchaseDialog";
import { QuickStudyDialog } from "@features/dashboard/components/QuickStudyDialog";
import { useProethicaCommandBarActions } from "@features/dashboard/hooks/useProethicaCommandBarActions";
import { useRegisterActions } from "@memorang/command-bar";
import { useState } from "react";

export const ModuleCommandBarActions = () => {
	const [showQuickStudyDialog, setShowQuickStudyDialog] = useState(false);
	const [showPurchaseDialog, setShowPurchaseDialog] = useState(false);
	const actions = useProethicaCommandBarActions({
		onOpenQuickStudy: () => setShowQuickStudyDialog(true),
		onShowPurchase: () => setShowPurchaseDialog(true),
	});
	useRegisterActions(actions);
	return (
		<>
			{showQuickStudyDialog && (
				<QuickStudyDialog
					visible={showQuickStudyDialog}
					handleClose={() => setShowQuickStudyDialog(false)}
				/>
			)}
			{showPurchaseDialog && (
				<PurchaseDialog
					visible={showPurchaseDialog}
					handleClose={() => setShowPurchaseDialog(false)}
					productType="STUDY_PACK"
				/>
			)}
		</>
	);
};
